import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Features from "./components/Features";
import AnimeSection from "./components/AnimeSection";
import Guide from "./components/Guide";
import Faq from "./components/Faq";
import About from "./components/About";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <Features />
        <AnimeSection />
        <Guide />
        <Faq />
        <About />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}